// src/services/notificationService.js
// Sino da topbar e resposta a convites. Tudo aqui é da própria pessoa e vale em
// qualquer contexto de login.
import api from "./api";

/**
 * As notificações mais recentes e quantas estão sem ler.
 * GET /api/notifications
 * @returns {Promise} NotificationListDto { items, unreadCount }
 */
export function getNotifications() {
  return api.get("/notifications");
}

/**
 * Abrir o sino marca tudo como lido.
 * POST /api/notifications/read-all
 * @returns {Promise} NotificationListDto
 */
export function markAllNotificationsRead() {
  return api.post("/notifications/read-all");
}

/**
 * Apaga as lidas e as resolvidas; convite pendente fica.
 * DELETE /api/notifications
 * @returns {Promise} NotificationListDto
 */
export function clearNotifications() {
  return api.delete("/notifications");
}

/**
 * DELETE /api/notifications/{id}
 * @param {number} id
 */
export function deleteNotification(id) {
  return api.delete(`/notifications/${id}`);
}

/**
 * Aceita o convite para entrar no círculo de um titular. O consentimento que
 * vale para o vínculo é este, de quem aceita.
 * POST /api/invitations/{id}/accept
 * @param {number} id
 * @param {object} consent - { consentTextSnapshot, termsVersion, privacyVersion }
 * @returns {Promise} { managerUserId, managerName, relationshipType }
 */
export function acceptInvitation(id, consent) {
  return api.post(`/invitations/${id}/accept`, consent);
}

/**
 * POST /api/invitations/{id}/decline
 * @param {number} id
 */
export function declineInvitation(id) {
  return api.post(`/invitations/${id}/decline`);
}
